import { ClickstreamEvent } from '../types';

export const logClickstreamEvent = (event: ClickstreamEvent) => {
    // eslint-disable-next-line no-console
    console.log('Clickstream Event Logged\n', JSON.stringify(event, null, 2));
};
